// extracted by mini-css-extract-plugin
export default {"popup":"NxPopup_popup__lktDo","header":"NxPopup_header__Eo31o","description":"NxPopup_description__cjFIh","footer":"NxPopup_footer__XsIqY"};